import { AsyncActionHandler } from 'action-handler';
import { repositionTiles } from 'actions/registry';

export default new AsyncActionHandler({
  name: 'reorder_tiles',
  handler: (tiles) => async (dispatch) => {
    const reqData = tiles.map((tile, index) => ({
      tileId: tile.id,
      position: index
    }));

    await dispatch(repositionTiles(reqData));

    await window.__webview_comms__.trigger('tiles-refresh');
  }
});
